import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { POSTS } from "./blogData";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function Blog() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-50 bg-slate-900/95 backdrop-blur-md text-white border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/"><Logo light /></Link>
          <Link to="/cadastro"><Button className="bg-sky-600 hover:bg-sky-500 text-white h-11" data-testid="blog-cta-btn">Começar grátis</Button></Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="blog-page">
        <p className="text-xs font-mono-num uppercase tracking-widest text-sky-700 font-semibold">Blog GEPR</p>
        <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight">Precificação e gestão para refrigeração</h1>
        <p className="mt-3 text-slate-600">Guias práticos para cobrar certo e organizar sua operação.</p>
        <div className="mt-10 grid gap-4">
          {POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`}>
              <Card className="border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-testid={`blog-card-${p.slug}`}>
                <CardContent className="p-5 flex items-center justify-between gap-4">
                  <div>
                    <p className="text-xs text-slate-400 font-mono-num">{fmtDate(p.date)}</p>
                    <h2 className="mt-1 font-semibold text-lg">{p.title}</h2>
                    <p className="mt-1 text-sm text-slate-600">{p.excerpt}</p>
                  </div>
                  <ArrowRight className="h-5 w-5 text-sky-600 shrink-0" />
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
